import { ILoadSocialProfileResponse } from '~api/RampPgApiSdk';
import { DEFAULT_MOBILE_DISPLAY_FORMAT, DEFAULT_MOBILE_VALUE_FORMAT } from '~constants/Constants';
import { IUserFormValues } from '~domain/entities/UserFormStore';
import { ConfigRepository } from '~repositories/ConfigRepository';
import { UserRepository } from '~repositories/UserRepository';
import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/RampService';
import { IPhoneNumberInputConfig } from '~types/config';
import { getDisplayFieldName } from '~utils/phone-number-helper';

export class PrefillUserFormUseCase {
    private provider: string;
    private profile: ILoadSocialProfileResponse;
    private userRepository: UserRepository;
    private configRepository: ConfigRepository;

    constructor(provider: string, profile: ILoadSocialProfileResponse) {
        this.profile = profile;
        this.provider = provider;
        this.userRepository = diContainer.get(serviceNames.userRepository);
        this.configRepository = diContainer.get(serviceNames.configRepository);
    }

    execute = async () => {
        const { userFormStore } = this.userRepository;
        const { mobileNumber: e164Number, ...restValues } = this.profile || {};
        const {
            iamConfig: { identifierReadonlyOnFill = false } = {},
            emailIdentifierFieldName,
            setReadonlyField,
            getFieldConfig
        } = this.configRepository;
        const mobileFieldName = 'mobileNumber';

        const mobileFieldConfig = (getFieldConfig(
            mobileFieldName
        ) as unknown) as IPhoneNumberInputConfig;
        if (mobileFieldConfig) {
            // HACK: `tel` inputType uses `mobileNumber` as field name to display social profile mobile number
            const {
                countryCodes,
                displayFormat = DEFAULT_MOBILE_DISPLAY_FORMAT,
                valueFormat = DEFAULT_MOBILE_VALUE_FORMAT
            } = mobileFieldConfig;
            if (e164Number && countryCodes?.length && countryCodes[0]) {
                identifierReadonlyOnFill && setReadonlyField(mobileFieldName);
                const { formatValue, parsePhoneNumber } = await import(
                    '~utils/phone-number-helper'
                );
                const phoneNumber = parsePhoneNumber(e164Number, countryCodes[0]);
                if (phoneNumber) {
                    restValues[mobileFieldName] = formatValue(phoneNumber, valueFormat);
                    restValues[getDisplayFieldName(mobileFieldName)] = formatValue(
                        phoneNumber,
                        displayFormat
                    );
                }
            }
        }

        const { emailAddress } = restValues;
        if (emailAddress) {
            // emailAddress may map to pcEmailAddress or emailAddress based on region
            identifierReadonlyOnFill && setReadonlyField(emailIdentifierFieldName as string);
            restValues[emailIdentifierFieldName as string] = emailAddress;
        }
        restValues.provider = this.provider;
        userFormStore.setValues(restValues as IUserFormValues);
    };
}
